import AnswerImg from '../../../atoms/AnswerImg/AnswerImg';
import Tooltip from '../../../atoms/UI/Tooltip/Tooltip';
import Icon from '../../../atoms/UI/Icon/Icon';
import React from 'react';
import {LabelText, RightWrap, RightAnswerTooltip} from './styles.js'
import AnswerComment from '../../../molecules/AnswerComment/AnswerComment';
import Marker from '../../../atoms/UI/forms/Marker/Marker';
import { MathJax } from 'better-react-mathjax';
import useIsMath from '@/core/hooks/useIsMath';
import { sanitizeHTML } from '@/core/hooks/useSanitizedHTML';
import { useTranslation } from 'react-i18next';


type TestingAnswerContentProps = {
    imgSrc?: string;
    label?: string;
    isComment?: boolean;
    isCorrect?: boolean;
    isSelected?: any;
    isDisabled?: boolean;
    commentText?: string;
    required?: boolean;
}

const TestingAnswerContent = ({
                                  imgSrc,
                                  label,
                                  isComment,
                                  isCorrect,
                                  isSelected,
                                  isDisabled,
                                  commentText,
                                  required

                              }: TestingAnswerContentProps) => {

    const sanitizedHTMLLabel = sanitizeHTML(label);
    const isMath = useIsMath(label);
    const { t } = useTranslation();
    const text_right = t('testing.right' as string);

    return (
        <div>
            <RightWrap>
                {imgSrc && <AnswerImg src={imgSrc} isDisabled={isDisabled} isSelected={isSelected} />}
                {label &&
                    <LabelText
                        className={`${isSelected ? 'active' : ''}`}

                        {...(isComment && {
                            isCorrect: isCorrect,
                        })}

                        isDisabled={isDisabled}>
                        {isMath ? <MathJax dynamic>
                            <span dangerouslySetInnerHTML={{ __html: sanitizedHTMLLabel }} />
                        </MathJax> :
                            <span dangerouslySetInnerHTML={{ __html: sanitizedHTMLLabel }} />
                        }
                        {required && <Marker>*</Marker>}
                    </LabelText>

                }
            </RightWrap>
            {/*Обозначить верный если выбран неправильный картиночный ответ*/}
            {isComment && isCorrect && imgSrc && !isSelected &&
                <RightAnswerTooltip>
                    <Tooltip arrowUp visible={true} ><Icon name='Check' xSmall/>{text_right}</Tooltip>
                </RightAnswerTooltip>
            }

            {commentText && isComment &&  <AnswerComment comment={commentText} />}
        </div>
    )
}

export default TestingAnswerContent